// A ground-view guard: the role-styled procedural figure standing at its
// post (phase D of the AOD Studio arc). Same build path as the player's
// figure — `humanoidPartsForRole` is deterministic per (role, seed), so a
// guard is the same guard every run.
import { useMemo } from 'react';
import { HumanoidMesh } from '../character/HumanoidMesh.js';
import { humanoidPartsForRole } from '../character/proceduralHumanoid.js';

export interface GuardFigureProps {
  readonly x: number;
  readonly z: number;
  readonly heading: number;
  /** Stable identity — the band seed plus the guard's post. */
  readonly seedKey: string;
  /** 0–1 wind-up progress while striking; leans the figure forward. */
  readonly lunge: number;
}

export function GuardFigure({ x, z, heading, seedKey, lunge }: GuardFigureProps) {
  const parts = useMemo(() => humanoidPartsForRole('guard', seedKey), [seedKey]);
  // A strike reads as a lean into the swing — no animation rig needed.
  const lean = lunge * 0.35;
  return (
    <group
      position={[x + Math.sin(heading) * lean, 0, z + Math.cos(heading) * lean]}
      rotation={[0, heading, 0]}
    >
      <HumanoidMesh parts={parts} scale={1} />
    </group>
  );
}
